import React from 'react';
import './Ratings.css';

const Rating = ({ value }) => {
	const starTotal = 5;
	const starPercentage = value / starTotal * 100;

	const starPercentageRounded = `${Math.round(starPercentage / 10) * 10}%`;

	return (
		<div
			className="RatingContainer"
			style={{
				display: 'inline-block',
				background: '#26e2ba',
				color: '#333',
				fontWeight: '400',
				fontSize: '12px',
				borderRadius: '3px',
				padding: '2px 5px',
				margin: '10px auto'
			}}
		>
			<div className="stars-outer">
				<div
					className="stars-inner"
					style={{
						width: starPercentageRounded
					}}
				/>
			</div>
			<span
				className
				style={{
					color: '#333',
					fontSize: '12px'
				}}
			>
				&nbsp; ( {value} )
			</span>
		</div>
	);
};

export default Rating;
